export default "__VITE_ASSET__DVl20Lji__"